module.exports = __webpack_public_path__ + "static/media/14D.9c252964.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/14D.svg
// module id = 50
// module chunks = 0